import moment from "moment";

export const DateRangeConfig = {
  DEFAULT_DATERANGE: {
    startDate: moment().subtract(1, "months").format("L"),
    endDate: moment().format("L"),
  },
  ALLTIME_DATERANGE: {
    startDate: moment([2000, 0]).format("L"),
    endDate: moment().format("L"),
  },
  MAX_DATERANGE: {
    days: 90,
  },
  ADV_OPTIONS: {
    range: "range",
    yearly: "yearly",
    alltime: "alltime",
  },
  ADV_ACTIONS: {
    dateFilterReset: "dateFilterReset",
    dateFilterAlltime: "dateFilterAlltime",
  },
};
